import { Component, OnInit } from '@angular/core';
import {CarsService} from '../services/cars.service';
import {MatHorizontalStepper} from '@angular/material';
import {MatStepperServiceService} from '../services/mat-stepper-service.service';
import {FormModel} from '../models/FormModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Reponse} from '../models/ReponseModel';
import {FormSinistreModel} from '../models/FormSinistreModel';
import {DateUtilsService} from '../services/date-utils.service';
import {BackendService} from '../services/backend.service';

@Component({
  selector: 'app-cars-form',
  templateUrl: './cars-form.component.html',
  styleUrls: ['./cars-form.component.css']
})
export class CarsFormComponent implements OnInit {
  currentYear: number;
  currentMonth: number;
  currentDay: number;
  defaultYearDateMEC = 2010;
  formModel: FormModel;
  marquesPopular: any[] = [];
  marquesNotPopular: any[] = [];
  models: any[] = [];
  alimentations: any[] = [];
  nombreChevaux: any[] = [];
  carrosseries: any[] = [];
  versions: any[] = [];
  stationnementReponses: any[] = [];
  usagesReponses: any[] = [];
  kilometrageReponses: any[] = [];
  isRemorqueReponses: any[] = [];
  financementReponses: any[] = [];
  isVehiculeActuellementAssureReponses: any[] = [];
  isVehiculeAmenagePMRReponses: any[] = [];
  isAssure36DerniersMoisReponses: any[] = [];
  bonusMalusReponses: number[] = [];
  bonusMalusValues: any[] = [];
  bonusMalusReponse = new Reponse('Valider', 'Valider', 'periodeAssure36DerniersMois');
  nbrAnneeBonusCinquanteReponses: any[] = [];
  periodeAssure36DerniersMoisReponses: any[] = [];
  eteResilie36DerniersMoisReponses: any[] = [];
  motifResiliation36DerniersMoisReponses: any[] = [];
  dureeNonPaiementReponses: any[];
  nombreAssureursResiliationNonPaiementReponses: any[];
  recidiveResiliationNonPaiementReponses: any[];
  contentieuxSoldeResiliationNonPaiementReponses: any[];
  dateResiliation36DerniersMoisReponse = new Reponse('Valider', 'Valider', 'isEuSinistres36DerniersMois');
  isEuSinistres36DerniersMoisReponses: any[] = [];
  nombreMaxSinistresADeclarer = 5;
  nombreMaxSinistresADeclarerForTemplate = Array(this.nombreMaxSinistresADeclarer);
  natureSinistres36DerniersMoisReponses: any[];
  isDelitDeFuiteSinistres36DerniersMoisReponses: any[];
  dateSinistre36DerniersMoisReponse: any[];
  isPresenceTiersSinistres36DerniersMoisReponses: any[];
  isInterventionForceDeLOrdreSinistres36DerniersMoisReponses: any[];
  poursuiteTribunalPoliceSinistres36DerniersMoisReponses: any[];
  isEuSanctionsPenalesOuAdministrativesReponses: any[] = [];
  isEuAlcoolemie36DerniersMoisReponses: any [] = [];
  dateDernierAlcoolemie36DerniersMoisReponse = new Reponse('Valider', 'Valider', 'isRefusTestAlcoolemie36DerniersMois');
  controleAlcoolemieSuiteA36DerniersMoisReponses: any[] = [];
  controleAlcoolemieMethode36DerniersMoisReponses: any[] = [];
  isRefusTestAlcoolemie36DerniersMoisReponses: any[] = [];
  isDelitDeFuiteAlcoolemie36DerniersMoisReponses: any[] = [];
  tauxAlcoolemie36DerniersMoisReponse = new Reponse('Valider', 'Valider', 'isAnnulationOuSuspensionPermis36DerniersMois');
  isEuStupefiant36DerniersMoisReponses: any[] = [];
  dateDernierStupefiant36DerniersMoisReponse = new Reponse('Valider', 'Valider', 'isRefusTestStupefiant36DerniersMois');
  controleStupefiantSuiteA36DerniersMoisReponses: any[] = [];
  controleStupefiantMethode36DerniersMoisReponses: any[] = [];
  isRefusTestStupefiant36DerniersMoisReponses: any[] = [];
  isDelitDeFuiteStupefiant36DerniersMoisReponses: any[] = [];
  isAnnulationOuSuspensionPermis36DerniersMoisReponses: any[] = [];
  annulationPermisAvecOuSansSinistre36DerniersMoisReponses: any[] = [];
  annulationPermisMotif36DerniersMoisReponses: any[] = [];
  dateInitialPermisApresAnnulationReponse = new Reponse('Valider', 'Valider', 'dateAnnulationPermis36DerniersMois');
  dateAnnulationPermis36DerniersMoisReponse = new Reponse('Valider', 'Valider', null);
  suspensionPermisMotif36DerniersMoisReponses: any[] = [];
  dateSuspensionPermis36DerniersMoisReponse = new Reponse('Valider', 'Valider', 'nombreSuspensionPermis36AvecSinistreDerniersMois');
  nombreSuspensionPermis36AvecSinistreDerniersMoisReponses: any[] = [];
  nombreSuspensionPermis36SansSinistreDerniersMoisReponses: any[] = [];
  nombreMoisSuspensionPermis36DerniersMoisReponses: any[] = [];
  dateInfractionPermis36DerniersMoisReponse = new Reponse('Valider', 'Valider', 'dateSanctionPermis36DerniersMois');
  dateSanctionPermis36DerniersMoisReponse = new Reponse('Valider', 'Valider', 'dureeSanction36DerniersMois');
  dureeSanction36DerniersMoisReponses: any[] = [];
  civiliteConducteurPrincipaleReponses: any[] = [];
  nomConducteurPrincipaleReponse = new Reponse('Valider', 'Valider', 'dateNaissanceConducteurPrincipal');
  dateNaissanceConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'datePermisConducteurPrincipal');
  datePermisConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'typePermisConducteurPrincipal');
  typePermisConducteurPrincipalReponses: any[] = [];
  paysConduiteHorsEuropeConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'titulaireCarteGrise');
  situationFamilialeConducteurPrincipalReponses: any[] = [];
  lienAvecConducteurPrincipalReponses: any[] = [];
  professionConducteurPrincipalReponses: any[] = [];
  titulaireCarteGriseReponses: any[] = [];
  adresseConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'contactConducteurPrincipal');
  contactConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'garantieSouhaiteeConducteurPrincipal');
  garantieSouhaiteeConducteurPrincipalReponses: any[] = [];
  isAjouterConducteurSecondairReponses: any[] = [];
  urlParams: any;
  urlMarquesImages: string;
  isLoading = true;
  isLinear = false;
  private _isConducteurSecondaireQuestion = false;
  _typeConducteur = 'conducteurPrincipal';
  codePostalProFormGroup: FormGroup;
  bonusMalusFormGroup: FormGroup;
  tauxAlcoolemieFormGroup: FormGroup;
  nomConducteurPrincipaleFormGroup: FormGroup;
  adresseConducteurPrincipaleFormGroup: FormGroup;
  contactConducteurPrincipaleFormGroup: FormGroup;
  stepsQuestionsLabels: {[key: string]: any};
  private currentQuestionIsAlcoolemieOrStupefiant = 'alcoolemie'; // pour savoire a quelle infraction faut il attribuer la sanction
  // Forms processing variables
  defaultFormValues: { [key: string]: any; } = {};
  initLabelsQuestions(): void {
    this.stepsQuestionsLabels = {
      eteAssure36DerniersMois: {
        conducteurPrincipal: 'Avez-vous été assuré au cours des 36 derniers mois ?',
        conducteurSecondaire: 'A-t-il(elle) été assuré(e) au cours des 36 derniers mois ?'},
      eteResilie36DerniersMoisReponses: {
        conducteurPrincipal: 'Avez-vous été résilié au cours des 36 derniers mois ?',
        conducteurSecondaire: 'A-t-il(elle) été résilié(e) au cours des 36 derniers mois ?'},
      nombreAssureursResiliationNonPaiement: {
        conducteurPrincipal: 'Combien d\'assureurs avez-vous eu au cours des 36 derniers mois ?',
        conducteurSecondaire: 'Combien d\'assureurs a-t-il(elle) eu au cours des 36 derniers mois ?'},
      isEuSinistres36DerniersMois: {
        conducteurPrincipal: 'Avez-vous eu des sinistres au cours des 36 derniers mois ?',
        conducteurSecondaire: 'A-t-il(elle) eu des sinistres au cours des 36 derniers mois ?'},
      isDelitDeFuiteSinistres36DerniersMois: {
        conducteurPrincipal: 'Avez-vous fait un délit de fuite lors du ',
        conducteurSecondaire: 'A-t-il(elle) fait un délit de fuite lors du '},
      isEuSanctionsPenalesOuAdministratives: {
        conducteurPrincipal: 'Avez-vous eu une sanction pénale ou administrative au cours des 5 dernières années ?',
        conducteurSecondaire: 'A-t-il(elle) eu une sanction pénale ou administrative au cours des 5 dernières années ?'},
      isEuAlcoolemie36DerniersMois: {
        conducteurPrincipal: 'Avez-vous eu un contrôle d\'alcoolémie positif  au cours des 5 dernières années ?',
        conducteurSecondaire: 'A-t-il(elle) eu un contrôle d\'alcoolémie positif  au cours des 5 dernières années ?'},
      isRefusTestAlcoolemie36DerniersMois: {
        conducteurPrincipal: 'Avez-vous refusé de faire le test ?',
        conducteurSecondaire: 'A-t-il(elle) refusé(e) de faire le test ?'},
      isDelitDeFuiteAlcoolemie36DerniersMois: {
        conducteurPrincipal: 'Avez-vous fait un délit de fuite ?',
        conducteurSecondaire: 'A-t-il(elle) fait un délit de fuite ?'},
      isEuStupefiant36DerniersMois: {
        conducteurPrincipal: 'Avez-vous eu un contrôle positif d\'usage de stupéfiants au cours des 5 dernières années ?',
        conducteurSecondaire: 'A-t-il(elle) eu un contrôle positif d\'usage de stupéfiants au cours des 5 dernières années ?'},
      isAnnulationOuSuspensionPermis36DerniersMois: {
        conducteurPrincipal: 'Avez vous eu une sanction suite à cette infraction ?',
        conducteurSecondaire: 'A-t-il(elle) eu une sanction suite à cette infraction ?'},
      nombreSuspensionPermis36AvecSinistreDerniersMois: {
        conducteurPrincipal: 'Combien de suspension de permis avez vous eu suite à un sinistre ?',
        conducteurSecondaire: 'Combien de suspension de permis a-t-il(elle) eu suite à un sinistre ?'},
      nombreSuspensionPermis36SansSinistreDerniersMois: {
        conducteurPrincipal: 'Combien de suspension de permis avez vous eu sans sinistre ?',
        conducteurSecondaire: 'Combien de suspension de permis a-t-il(elle) eu sans sinistre ?'},
      paysConduiteHorsEuropeConducteurPrincipal: {
        conducteurPrincipal: 'Est ce que vous conduisez votre véhicule dans ces pays ?',
        conducteurSecondaire: 'Est ce que le conducteur secondaire conduits un véhicule dans ces pays ?'},

    };
  }
  getStepQuestionLabel(stepKey: string, versionQuestion: string): string {
    return this.stepsQuestionsLabels[stepKey][versionQuestion];
  }
  get isConducteurSecondaireQuestion(): boolean {
    return this._isConducteurSecondaireQuestion;
  }

  set isConducteurSecondaireQuestion(value: boolean) {
    (value === true ) ? this._typeConducteur = 'conducteurSecondaire' : this._typeConducteur = 'conducteurPrincipal';
    this._isConducteurSecondaireQuestion = value;
  }
  getSourceUrl(): string {
    if (document.referrer.toLowerCase().includes('zenithassurances.com')) {
     return 'https://zenithassurances.com';
    }
    if (document.referrer.toLowerCase().includes('zenith-assurances.fr')) {
      return 'https://www.zenith-assurances.fr';
    }
    return 'Unhandled source url';
  }
  sendMsgToParentOfIframe(msg: string): void {
    parent.postMessage( msg, this.getSourceUrl() );
  }
  constructor(private _matStepperServiceService: MatStepperServiceService, private _carService: CarsService, private _formBuilder: FormBuilder,
              private _dateUtilsService: DateUtilsService, private _backEndService: BackendService) { }

  ngOnInit(): void {
    this.initLabelsQuestions();
    this._backEndService.getServerDateAndTime().subscribe(data => {
      this.currentYear =  parseInt(data.currYear, 10);
      this.currentMonth = parseInt(data.currMonth, 10);
      this.currentDay = parseInt(data.currDay, 10);
      if (this.currentDay === 31) {
        this.currentDay = 30; // temporary pour eviter prob des dates ex : 31/06 est incorrecte
      }
      this.defaultFormValues.datePermisDefaultYearProspect = this.currentYear;
    });
    this.formModel = new FormModel();
    this.formModel.urlSource = document.referrer;
    this.urlParams = this._backEndService.getParams(this.formModel.urlSource);
    if (this.urlParams.keyword !== undefined) {
      this.formModel.keyword = this.urlParams.keyword;
    }
    this.formModel.deviceType = this._backEndService.getDeviceType();
    this.urlMarquesImages = this._carService.getUrlMarquePopularImages();
    this.formModel.vehicule.yearDateMEC = this.defaultYearDateMEC;
    this.usagesReponses.push(
      //new Reponse('Promenades privées', 'Déplacements privés', 'kilometrage'),
      //new Reponse('Privés et trajet travail', 'Déplacements privés et trajet travail', 'codePostalPro'),
      //new Reponse('Tournées régulières', 'Tournées régulières', 'kilometrage'),
      //new Reponse('Affaires commerces/ Professionnels', 'Affaire/Commerce', 'codePostalPro'),
      //new Reponse('Taxi', 'Taxi', 'codePostalPro'),
      new Reponse('VTC',  'VTC', 'codePostalPro'),
      //new Reponse('Agricole', 'Agricole', 'codePostalPro')
    );
    this.codePostalProFormGroup = this._formBuilder.group({
      codePostalPro: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(/^-?([0-9]\d*)?$/) ]]
    });
    this.kilometrageReponses.push({label: 'De 0 A 4999 KM', value: 'De 0 A 4999 KM'},
      {label: 'De 5000 A 7999 KM', value: 'De 5000 A 7999 KM'},
      {label: 'De 8000 A 11999 KM', value: 'De 8000 A 11999 KM'},
      {label: 'De 12000 A 15999 KM', value: 'De 12000 A 15999 KM'},
      {label: 'De 16000 A Plus', value: 'De 16000 A Plus'});
    this.stationnementReponses.push({label: 'Voie publique', value: 'Voie publique'},
      {label: 'Garage', value: 'Garage'},
      {label: 'Box', value: 'Box'},
      {label: 'parking couvert collectif', value: 'parking couvert collectif'},
      {label: 'Parking collectif plein air', value: 'Parking Collectif Plein Air'},
      {label: 'Jardin clos privé', value: 'Jardin Clos Prive'},
      {label: 'Garage public surveillé', value: 'Garage Public Surveille'});
    this.financementReponses.push({label: 'Comptant', value: 'Comptant'},
      {label: 'Crédit', value: 'Crédit'},
      {label: 'Leasing', value: 'Leasing'});
    this.isAssure36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'isEuSanctionsPenalesOuAdministratives'),
      new Reponse('Oui AVEC 9 mois d\'assurance consécutifs', 'ouiAvec9MoisConsecutifs', 'bonusMalus'),
      new Reponse('Oui SANS 9 mois d\'assurance consécutifs', 'ouiSans9MoisConsecutifs', 'bonusMalus'));
    this.isRemorqueReponses.push(new Reponse( 'Non', 'Non', 'isVehiculeActuellementAssure'),
      new Reponse( 'Oui, moins de 750 Kg', 'Oui_moins_750', 'isVehiculeActuellementAssure'),
      new Reponse( 'Oui, plus ou égal à 750 Kg', 'Oui_plus_750', 'isVehiculeActuellementAssure'));
    this.isVehiculeActuellementAssureReponses.push(new Reponse( 'Oui', 'OUI', 'isVehiculeAmenagePMR'),
      new Reponse( 'Non depuis moins de 3 mois', 'NON_DEPUIS_MOINS_DE_3_MOIS', 'isVehiculeAmenagePMR'),
      new Reponse( 'Non depuis moins de 6 mois', 'NON_DEPUIS_MOINS_DE_6_MOIS', 'isVehiculeAmenagePMR'),
      new Reponse( 'Non depuis moins de 12 mois', 'NON_DEPUIS_MOINS_DE_12_MOIS', 'isVehiculeAmenagePMR'),
      new Reponse( 'Non depuis plus de 12 mois', 'NON_DEPUIS_12_MOIS_ET_PLUS', 'isVehiculeAmenagePMR'));
    this.isVehiculeAmenagePMRReponses.push(new Reponse( 'Non', 'Non', 'eteAssure36DerniersMois'),
      new Reponse( 'Oui', 'Oui', 'eteAssure36DerniersMois'));
    this.bonusMalusFormGroup = this._formBuilder.group({
      bonusMalus: [1, [Validators.required]]
    });
    // init bonus values
    for (let i = 0.5; i <= 1; i += 0.01) {
      const iToFixed = i.toFixed(2);
      // this.bonusMalusValues.push({value: iToFixed, viewValue: iToFixed + ' soit ' + (50 - parseInt(String((parseFloat(iToFixed) - 0.5) * 100), 10)) + '% de bonus'});
      this.bonusMalusValues.push({value: iToFixed, viewValue: iToFixed + ' soit ' + Math.round(50 - (parseFloat(iToFixed) - 0.5) * 100) + '% de bonus'});
    }
    this.bonusMalusValues.push({value: 1, viewValue: '1.00 soit ni bonus ni malus'});
    for (let i = 1.01; i <= 3.5; i += 0.01) {
      const iToFixed = i.toFixed(2);
      // this.bonusMalusValues.push({value: iToFixed, viewValue: iToFixed + ' soit ' + (50 - parseInt(String((parseFloat(iToFixed) - 0.5) * 100), 10)) + '% de bonus'});
      this.bonusMalusValues.push({value: iToFixed, viewValue: iToFixed + ' soit ' + Math.round((parseFloat(iToFixed) - 1) * 100) + '% de malus'});
    }
    // this.bonusMalusValues = [{value: 1, viewValue: '1212'}];
    for (let i = 0.5; i < 3.5; i += 0.01) {this.bonusMalusReponses.push(i); }
    // this.formModel[this._typeConducteur].antecedents.bonusMalus = 0.5;
    for (let i = 0; i <= 12; i += 1) { this.nbrAnneeBonusCinquanteReponses.push(
      new Reponse('' + i, '' + i, 'periodeAssure36DerniersMois')); }
    for (let i = 1; i <= 36; i++) {
      this.periodeAssure36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'eteResilie36DerniersMois'));
    }
    this.eteResilie36DerniersMoisReponses.push(new Reponse('Non', '0', 'isEuSinistres36DerniersMois'),
      new Reponse('Oui', '1', 'motifResiliation36DerniersMois'));
    this.motifResiliation36DerniersMoisReponses.push(new Reponse('Non paiement', 'non paiement', 'dureeNonPaiement'),
      new Reponse('Alcoolémie', 'alcoolemie', 'dateResiliation36DerniersMois'),
      new Reponse('Stupéfiant', 'stupefiant', 'dateResiliation36DerniersMois'),
      new Reponse('Défaut d\'assurance', 'Defaut assurance', 'dateResiliation36DerniersMois'),
      new Reponse('Conduite sans permis', 'conduite sans permis', 'dateResiliation36DerniersMois'),
      new Reponse('Refus d\'obtempérer', 'refus obtemperer', 'dateResiliation36DerniersMois'),
      new Reponse('Excès de vitesse', 'Exces de vitesse', 'dateResiliation36DerniersMois'),
      new Reponse('Perte de points', 'Perte de points', 'dateResiliation36DerniersMois'),
      new Reponse('Résiliation client', 'resiliation client', 'dateResiliation36DerniersMois'),
      new Reponse('Sinistre', 'sinistre', 'dateResiliation36DerniersMois'),
      new Reponse('Sinistre et non paiement de prime', 'sinistre et non paiement de prime', 'dateResiliation36DerniersMois'),
      new Reponse('Délit de fuite', 'delit fuite', 'dateResiliation36DerniersMois'),
      new Reponse('Nullité de contrat', 'Nulite Contrat', 'dateResiliation36DerniersMois'),
      new Reponse('Sinistre et alcoolémie', 'sinistre et alcoolemie', 'dateResiliation36DerniersMois'),
      new Reponse('Sinistre et stupéfiant', 'sinistre et stupefiant', 'dateResiliation36DerniersMois'),
      new Reponse('Fausse déclaration', 'fausse declaration', 'dateResiliation36DerniersMois'),
      new Reponse('Suspension ou annulation du permis', 'suspension annulation permis', 'dateResiliation36DerniersMois'),
      new Reponse('Autres motifs', 'Autres motif', 'dateResiliation36DerniersMois'),
  );
    this.isEuSinistres36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'isEuSanctionsPenalesOuAdministratives'));
    for (let i = 1; i <= 4; i++) {this.isEuSinistres36DerniersMoisReponses.push(new Reponse('Oui, ' + i, '' + i,
      'natureSinistres36DerniersMois_0')); }
    this.isEuSinistres36DerniersMoisReponses.push(new Reponse('Oui, plus de 4', '5', 'natureSinistres36DerniersMois_0'));
    // 5 nombre Max de sinistre à déclarer
    this.formModel.conducteurPrincipal.antecedents.sinistres36DerniersMois = new Array(this.nombreMaxSinistresADeclarer);
    this.formModel.conducteurSecondaire.antecedents.sinistres36DerniersMois = new Array(this.nombreMaxSinistresADeclarer);
    for (let i = 0; i < this.formModel.conducteurPrincipal.antecedents.sinistres36DerniersMois.length; i++) {
      this.formModel.conducteurPrincipal.antecedents.sinistres36DerniersMois[i] = new FormSinistreModel();
      this.formModel.conducteurSecondaire.antecedents.sinistres36DerniersMois[i] = new FormSinistreModel();
    }
    this.natureSinistres36DerniersMoisReponses = new Array(this.nombreMaxSinistresADeclarer);
    for (let i = 0; i < this.natureSinistres36DerniersMoisReponses.length; i++) {
      this.natureSinistres36DerniersMoisReponses[i] = [
        new Reponse('Matériel non responsable', 'Materiel non responsable', 'isPresenceTiersSinistres36DerniersMois_' + i),
        new Reponse('Matériel totalement responsable', 'Materiel responsable', 'isPresenceTiersSinistres36DerniersMois_' + i),
        new Reponse('Matériel partiellement responsable', 'Materiel responsable 50', 'isPresenceTiersSinistres36DerniersMois_' + i),
        new Reponse('Corporel Non responsable', 'Corporel Non responsable', 'isDelitDeFuiteSinistres36DerniersMois_' + i),
        new Reponse('Corporel totalement responsable', 'Corporel responsable', 'isDelitDeFuiteSinistres36DerniersMois_' + i),
        new Reponse('Corporel Partiellement responsable', 'Corporel Partiellement responsable', 'isDelitDeFuiteSinistres36DerniersMois_' + i),
        new Reponse('Bris de glace', 'bris de glace', 'dateSinistre36DerniersMois_' + i),
        new Reponse('Vol', 'Vol', 'dateSinistre36DerniersMois_' + i),
        new Reponse('Vandalisme', 'Vandalisme', 'dateSinistre36DerniersMois_' + i),
        new Reponse('Incendie', 'Incendie', 'dateSinistre36DerniersMois_' + i),
        new Reponse('Evenements catastrophes naturelles', 'Evenement naturels', 'dateSinistre36DerniersMois_' + i),
        new Reponse('Dommages en stationnement', 'Dommages en stationnement', 'isPresenceTiersSinistres36DerniersMois_' + i),
        ];
    }
    this.isDelitDeFuiteSinistres36DerniersMoisReponses = new Array(this.nombreMaxSinistresADeclarer);
    this.isPresenceTiersSinistres36DerniersMoisReponses = new Array(this.nombreMaxSinistresADeclarer);
    this.isInterventionForceDeLOrdreSinistres36DerniersMoisReponses = new Array(this.nombreMaxSinistresADeclarer);
    this.poursuiteTribunalPoliceSinistres36DerniersMoisReponses = new Array(this.nombreMaxSinistresADeclarer);

    this.dateSinistre36DerniersMoisReponse = new Array(this.nombreMaxSinistresADeclarer);
    for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {
      this.isDelitDeFuiteSinistres36DerniersMoisReponses[i] = [new Reponse('Non', 'Non', 'isInterventionForceDeLOrdreSinistres36DerniersMois_'.concat( (i).toString() ) ),
        new Reponse('Oui', 'Oui', 'isInterventionForceDeLOrdreSinistres36DerniersMois_'.concat( (i).toString() ))];
    }
    for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {
      this.isInterventionForceDeLOrdreSinistres36DerniersMoisReponses[i] = [new Reponse('Non', 'Non', 'poursuiteTribunalPoliceSinistres36DerniersMois_'.concat( (i).toString() )),
        new Reponse('Oui', 'Oui', 'poursuiteTribunalPoliceSinistres36DerniersMois_'.concat( (i).toString() ))];
    }
    for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {
      this.poursuiteTribunalPoliceSinistres36DerniersMoisReponses[i] = [new Reponse('Aucun', 'AUCUN', 'isPresenceTiersSinistres36DerniersMois_'.concat( (i).toString() )),
        new Reponse('Tribunal de police', 'TRIBUNAL_POLICE', 'isPresenceTiersSinistres36DerniersMois_'.concat( (i).toString() )),
        new Reponse('Tribunal correctionnel', 'TRIBUNAL_CORRECTIONNEL', 'isPresenceTiersSinistres36DerniersMois_'.concat( (i).toString() ))];
    }
    for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {
      this.isPresenceTiersSinistres36DerniersMoisReponses[i] = [new Reponse('Non', 'Non', 'dateSinistre36DerniersMois_'.concat( (i).toString() )),
        new Reponse('Oui', 'Oui', 'dateSinistre36DerniersMois_'.concat( (i).toString() ))];
    }
    for (let i = 0; i < this.dateSinistre36DerniersMoisReponse.length; i++) {
      this.dateSinistre36DerniersMoisReponse[i] = new Reponse('Valider', 'Valider',
        'natureSinistres36DerniersMois_'.concat( (i + 1).toString() ));
    }
    this.isEuSanctionsPenalesOuAdministrativesReponses.push(new Reponse('Non', 'Non', 'civiliteConducteurPrincipale'),
      new Reponse('Oui', 'Oui', 'isEuAlcoolemie36DerniersMois'));
    this.isEuAlcoolemie36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'isEuStupefiant36DerniersMois'));
    for (let i = 1; i <= 2; i++) {this.isEuAlcoolemie36DerniersMoisReponses.push(new Reponse('Oui, ' + i, '' + i,
      'dateDernierAlcoolemie36DerniersMois')); }
    this.isEuAlcoolemie36DerniersMoisReponses.push(new Reponse('Oui, plus de 2', '3', 'dateDernierAlcoolemie36DerniersMois'));
    this.isRefusTestAlcoolemie36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'isDelitDeFuiteAlcoolemie36DerniersMois'),
      new Reponse('Oui', 'Oui', 'isDelitDeFuiteAlcoolemie36DerniersMois'));
    this.isDelitDeFuiteAlcoolemie36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'controleAlcoolemieSuiteA36DerniersMois'),
      new Reponse('Oui', 'Oui', 'controleAlcoolemieSuiteA36DerniersMois'));
    this.controleAlcoolemieSuiteA36DerniersMoisReponses.push(new Reponse('Contrôle routier', 'Controle routier', 'controleAlcoolemieMethode36DerniersMois'),
      new Reponse('Sinistre', 'sinistre', 'controleAlcoolemieMethode36DerniersMois'));
    this.controleAlcoolemieMethode36DerniersMoisReponses.push(new Reponse('Prise de sang', 'prise de sang', 'tauxAlcoolemie36DerniersMois'),
      new Reponse('Ethylotest', 'ethylotest', 'tauxAlcoolemie36DerniersMois'));
    this.tauxAlcoolemieFormGroup = this._formBuilder.group({
      tauxAlcoolemie: ['', [Validators.required, Validators.pattern(/^[+-]?[0-9]*\.?[0-9]+$/) ]]
    });
    this.isEuStupefiant36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'civiliteConducteurPrincipale'));
    for (let i = 1; i <= 2; i++) {this.isEuStupefiant36DerniersMoisReponses.push(new Reponse('Oui, ' + i, '' + i, 'dateDernierStupefiant36DerniersMois')); }
    this.isEuStupefiant36DerniersMoisReponses.push(new Reponse('Oui, plus de 2', '3', 'dateDernierStupefiant36DerniersMois'));
    this.isRefusTestStupefiant36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'isDelitDeFuiteStupefiant36DerniersMois'),
      new Reponse('Oui', 'Oui', 'isDelitDeFuiteStupefiant36DerniersMois'));
    this.isDelitDeFuiteStupefiant36DerniersMoisReponses.push(new Reponse('Non', 'Non', 'controleStupefiantSuiteA36DerniersMois'),
      new Reponse('Oui', 'Oui', 'controleStupefiantSuiteA36DerniersMois'));
    this.controleStupefiantSuiteA36DerniersMoisReponses.push(new Reponse('Contrôle routier', 'Controle routier', 'controleStupefiantMethode36DerniersMois'),
      new Reponse('Sinistre', 'sinistre', 'controleStupefiantMethode36DerniersMois'));
    this.controleStupefiantMethode36DerniersMoisReponses.push(new Reponse('Test salivaire', 'ethylotest', 'isAnnulationOuSuspensionPermis36DerniersMois'),
      new Reponse('Prise de sang', 'prise de sang', 'isAnnulationOuSuspensionPermis36DerniersMois'));
    this.isAnnulationOuSuspensionPermis36DerniersMoisReponses.push(
      new Reponse('Non', 'AUCUNE', 'civiliteConducteurPrincipale'),
      new Reponse('Oui, Annulation du permis', 'annulation_permis', 'annulationPermisAvecOuSansSinistre36DerniersMois'),
      new Reponse('Oui, Suspension du permis', 'suspension_permis', 'dateSuspensionPermis36DerniersMois'),
      new Reponse('Oui, Attente jugement', 'ATTENTE_JUGEMENT', 'dateSanctionPermis36DerniersMois'),
      new Reponse('Oui, Composition pénale', 'COMPOSITION_PENALE', 'dateSanctionPermis36DerniersMois'),
      new Reponse('Oui, Contravention', 'CONTRAVENTION_4', 'civiliteConducteurPrincipale'),
      new Reponse('Oui, Peine de prison', 'PEINE_PRISON', 'civiliteConducteurPrincipale'),
      new Reponse('Oui, Annulation permis + Peine de prison', 'ANNULATION_PERMIS_PEINE_PRISON', 'annulationPermisAvecOuSansSinistre36DerniersMois'),
      new Reponse('Oui, Suspension permis + Peine de prison', 'SUSPENSION_PERMIS_PEINE_PRISON', 'dateSuspensionPermis36DerniersMois'),
      // new Reponse('Oui, Annulation du permis', 'annulation_permis', 'annulationPermisAvecOuSansSinistre36DerniersMois'),
      // new Reponse('Oui, Suspension du permis', 'suspension_permis', 'suspensionPermisMotif36DerniersMois'),
      // new Reponse('Oui, les deux', 'annulation_et_suspension_permis', 'annulationPermisAvecOuSansSinistre36DerniersMois')
      );
    this.annulationPermisAvecOuSansSinistre36DerniersMoisReponses.push(new Reponse('Non', 'Avec sinistre', 'dateInitialPermisApresAnnulation'),
      new Reponse('Oui', 'Sans sinistre', 'dateInitialPermisApresAnnulation')
      );
    this.annulationPermisMotif36DerniersMoisReponses.push(new Reponse('Defaut point', '', 'dateAnnulationPermis36DerniersMois'),
      new Reponse('Délit de fuite', 'Delit de fuite', 'dateAnnulationPermis36DerniersMois'),
      new Reponse('Alcoolémie', 'Alcoolemie', 'dateAnnulationPermis36DerniersMois'),
      new Reponse('Défaut d\'ssurance', 'Defaut Assurance', 'dateAnnulationPermis36DerniersMois'),
      new Reponse('Stupéfiant', 'Stupefiant', 'dateAnnulationPermis36DerniersMois'),
      new Reponse('Retrait total', 'Retrait Total', 'dateAnnulationPermis36DerniersMois'),
      new Reponse('Autre motif', 'Autre motif', 'dateAnnulationPermis36DerniersMois'));
    this.suspensionPermisMotif36DerniersMoisReponses.push(new Reponse('Defaut point', '', 'dateSuspensionPermis36DerniersMois'),
      new Reponse('Délit de fuite', 'Delit de fuite', 'dateSuspensionPermis36DerniersMois'),
      new Reponse('Alcoolémie', 'Alcoolemie', 'dateSuspensionPermis36DerniersMois'),
      new Reponse('Défaut d\'ssurance', 'Defaut Assurance', 'dateSuspensionPermis36DerniersMois'),
      new Reponse('Stupéfiant', 'Stupefiant', 'dateSuspensionPermis36DerniersMois'),
      new Reponse('Retrait total', 'Retrait Total', 'dateSuspensionPermis36DerniersMois'),
      new Reponse('Autre motif', 'Autre motif', 'dateSuspensionPermis36DerniersMois'));
    for (let i = 0; i <= 9; i++) {
      this.nombreSuspensionPermis36AvecSinistreDerniersMoisReponses.push(new Reponse('' + i, '' + i, 'nombreSuspensionPermis36SansSinistreDerniersMois'));
      this.nombreSuspensionPermis36SansSinistreDerniersMoisReponses.push(new Reponse('' + i, '' + i, 'nombreMoisSuspensionPermis36DerniersMois'));
    }
    for (let i = 1; i <= 36; i++) {this.nombreMoisSuspensionPermis36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'civiliteConducteurPrincipale')); }
    for (let i = 1; i <= 36; i++) {this.dureeSanction36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'civiliteConducteurPrincipale')); }
    this.initConducteurPrincipalReponses();
    this.isAjouterConducteurSecondairReponses.push(new Reponse('Non', 'Non', 'confirmation'),
      new Reponse('Oui', 'Oui', 'eteAssure36DerniersMois'));
  }
  initConducteurPrincipalReponses(): void {
    this.civiliteConducteurPrincipaleReponses = [];
    this.typePermisConducteurPrincipalReponses = [];
    this.situationFamilialeConducteurPrincipalReponses = [];
    this.professionConducteurPrincipalReponses = [];
    this.titulaireCarteGriseReponses = [];
    this.garantieSouhaiteeConducteurPrincipalReponses = [];
    this.datePermisConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'typePermisConducteurPrincipal');
    this.contactConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'garantieSouhaiteeConducteurPrincipal');
    this.civiliteConducteurPrincipaleReponses.push(new Reponse('Monsieur', 'Monsieur', 'nomConducteurPrincipale'),
      new Reponse('Madame', 'Madame', 'nomConducteurPrincipale'),
      new Reponse('Mademoiselle', 'Mlle', 'nomConducteurPrincipale'));
    this.nomConducteurPrincipaleFormGroup = this._formBuilder.group({
      nom: ['', [Validators.required]],
      prenom: ['', [Validators.required]]
    });
    this.typePermisConducteurPrincipalReponses.push(new Reponse('Union européenne', 'Union Europeen', 'titulaireCarteGrise'),
      new Reponse('Hors union européenne', 'Hors Union', 'paysConduiteHorsEuropeConducteurPrincipal'));
    this.situationFamilialeConducteurPrincipalReponses.push(new Reponse('Célibataire', 'C', 'professionConducteurPrincipal'),
      new Reponse('Marié(e)', 'M', 'professionConducteurPrincipal'),
      new Reponse('Concubin(e)', 'VM', 'professionConducteurPrincipal'),
      new Reponse('Divorcé(e)', 'D', 'professionConducteurPrincipal'),
      new Reponse('Pacsé(e)', 'PA', 'professionConducteurPrincipal'),
      new Reponse('Séparé(e)', 'SE', 'professionConducteurPrincipal'),
      new Reponse('Veuf(ve))', 'V', 'professionConducteurPrincipal'));
    this.professionConducteurPrincipalReponses.push(new Reponse('Salarié sédentaire', 'Salarié sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Salarié non sédentaire', 'Salarié NON sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Artisan', 'Artisan', 'adresseConducteurPrincipal'),
      new Reponse('Auto entrepreneur', 'Auto entrepreneur', 'adresseConducteurPrincipal'),
      new Reponse('Commerçant', 'Commerçant', 'adresseConducteurPrincipal'),
      new Reponse('Ecclésiastique', 'Ecclésiastique', 'adresseConducteurPrincipal'),
      new Reponse('Etudiant(e)', 'Etudiant', 'adresseConducteurPrincipal'),
      new Reponse('Exploitant agricole', 'Exploitant agricole', 'adresseConducteurPrincipal'),
      new Reponse('Fonctionnaire non sédentaire', 'Fonctionnaire non sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Fonctionnaire sédentaire', 'Fonctionnaire sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Gérant de société', 'Gerant de societe', 'adresseConducteurPrincipal'),
      new Reponse('Profession libérale non sédentaire', 'Profession libérale non sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Profession libérale sédentaire', 'Profession libérale sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Sans profession', 'Sans profession', 'adresseConducteurPrincipal'),
      new Reponse('Retraité(e)', 'Retraite', 'adresseConducteurPrincipal'),
      new Reponse('TAXI', 'TAXI', 'adresseConducteurPrincipal'),
      new Reponse('VTC', 'VTC', 'adresseConducteurPrincipal'),
      new Reponse('VRP', 'VRP', 'adresseConducteurPrincipal'));
    this.titulaireCarteGriseReponses.push(new Reponse('Conducteur principal', 'Conducteur Principal', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Conjoint ou concubin', 'Conjoint Ou Concubin', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Conducteur et conjoint Concubin', 'Conducteur1 Et Conjoint Concubin', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Parents', 'Parents', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Parents du conjoint concubin', 'Parents Du Conjoint Concubin', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Société', 'Societe', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Société de leasing', 'Societe De Leasing', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Enfant', 'Enfant', 'situationFamilialeConducteurPrincipal'));
    this.adresseConducteurPrincipaleFormGroup = this._formBuilder.group({
      adresse: ['', [Validators.required, Validators.maxLength(500)]],
      codePostal: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(/^-?([0-9]\d*)?$/) ]],
      ville: ['', [Validators.required]]
    });
    this.contactConducteurPrincipaleFormGroup = this._formBuilder.group({
      tel: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]]
    });
    this.garantieSouhaiteeConducteurPrincipalReponses.push(new Reponse('Tiers simple', 'Tiers simple', 'isAjouterConducteurSecondair'),
      new Reponse('Intermédiaire', 'Intermediaire', 'isAjouterConducteurSecondair'),
      new Reponse('Tous risques', 'Tous risques', 'isAjouterConducteurSecondair'));
  }
  initConducteurPrincipalReponsesOnGoBackFromConducteurSecondaireQuestion(): void {
    this.situationFamilialeConducteurPrincipalReponses = [];
    this.professionConducteurPrincipalReponses = [];
    this.typePermisConducteurPrincipalReponses = [];
    // this.datePermisConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'typePermisConducteurPrincipal');
    this.typePermisConducteurPrincipalReponses.push(new Reponse('Union européenne', 'Union Europeen', 'titulaireCarteGrise'),
      new Reponse('Hors union européenne', 'Hors Union', 'paysConduiteHorsEuropeConducteurPrincipal'));
    this.paysConduiteHorsEuropeConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'titulaireCarteGrise');
    this.situationFamilialeConducteurPrincipalReponses.push(new Reponse('Célibataire', 'C', 'professionConducteurPrincipal'),
      new Reponse('Marié(e)', 'M', 'professionConducteurPrincipal'),
      new Reponse('Concubin(e)', 'VM', 'professionConducteurPrincipal'),
      new Reponse('Divorcé(e)', 'D', 'professionConducteurPrincipal'),
      new Reponse('Pacsé(e)', 'PA', 'professionConducteurPrincipal'),
      new Reponse('Séparé(e)', 'SE', 'professionConducteurPrincipal'),
      new Reponse('Veuf(ve))', 'V', 'professionConducteurPrincipal'));
    this.professionConducteurPrincipalReponses.push(new Reponse('Salarié sédentaire', 'Salarié sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Salarié non sédentaire', 'Salarié NON sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Artisan', 'Artisan', 'adresseConducteurPrincipal'),
      new Reponse('Auto entrepreneur', 'Auto entrepreneur', 'adresseConducteurPrincipal'),
      new Reponse('Commerçant', 'Commerçant', 'adresseConducteurPrincipal'),
      new Reponse('Ecclésiastique', 'Ecclésiastique', 'adresseConducteurPrincipal'),
      new Reponse('Etudiant(e)', 'Etudiant', 'adresseConducteurPrincipal'),
      new Reponse('Exploitant agricole', 'Exploitant agricole', 'adresseConducteurPrincipal'),
      new Reponse('Fonctionnaire non sédentaire', 'Fonctionnaire non sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Fonctionnaire sédentaire', 'Fonctionnaire sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Gérant de société', 'Gérant de société', 'adresseConducteurPrincipal'),
      new Reponse('Profession libérale non sédentaire', 'Profession libérale non sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Profession libérale sédentaire', 'Profession libérale sédentaire', 'adresseConducteurPrincipal'),
      new Reponse('Sans profession', 'Sans profession', 'adresseConducteurPrincipal'),
      new Reponse('Retraité(e)', 'Retraite', 'adresseConducteurPrincipal'),
      new Reponse('TAXI', 'TAXI', 'adresseConducteurPrincipal'),
      new Reponse('VTC', 'VTC', 'adresseConducteurPrincipal'),
      new Reponse('VRP', 'VRP', 'adresseConducteurPrincipal'));
  }
  initConducteurSecondaireReponses(): void {
    this.situationFamilialeConducteurPrincipalReponses = [];
    this.professionConducteurPrincipalReponses = [];
    this.typePermisConducteurPrincipalReponses = [];
    // this.datePermisConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'situationFamilialeConducteurPrincipal');
    this.typePermisConducteurPrincipalReponses.push(new Reponse('Union européenne', 'Union Europeen', 'situationFamilialeConducteurPrincipal'),
      new Reponse('Hors union européenne', 'Hors Union', 'paysConduiteHorsEuropeConducteurPrincipal'));
    this.paysConduiteHorsEuropeConducteurPrincipalReponse = new Reponse('Valider', 'Valider', 'situationFamilialeConducteurPrincipal');
    this.situationFamilialeConducteurPrincipalReponses.push(new Reponse('Célibataire', 'C', 'lienAvecConducteurPrincipal'),
      new Reponse('Marié(e)', 'M', 'lienAvecConducteurPrincipal'),
      new Reponse('Concubin(e)', 'VM', 'lienAvecConducteurPrincipal'),
      new Reponse('Divorcé(e)', 'D', 'lienAvecConducteurPrincipal'),
      new Reponse('Pacsé(e)', 'PA', 'lienAvecConducteurPrincipal'),
      new Reponse('Séparé(e)', 'SE', 'lienAvecConducteurPrincipal'),
      new Reponse('Veuf(ve))', 'V', 'lienAvecConducteurPrincipal'));
    this.lienAvecConducteurPrincipalReponses.push(new Reponse('Conjoint', 'CONJOINT', 'professionConducteurPrincipal'),
      new Reponse('Concubin', 'CONCUBIN', 'professionConducteurPrincipal'),
      new Reponse('Partenaire pacs', 'PARTENAIRE_PACS', 'professionConducteurPrincipal'),
      new Reponse('Enfant', 'ENFANT', 'professionConducteurPrincipal'),
      new Reponse('Autre', 'AUTRE', 'professionConducteurPrincipal'));
    this.professionConducteurPrincipalReponses.push(new Reponse('Salarié sédentaire', 'Salarié sédentaire', 'confirmation'),
    new Reponse('Salarié non sédentaire', 'Salarié NON sédentaire', 'confirmation'),
    new Reponse('Artisan', 'Artisan', 'confirmation'),
    new Reponse('Auto entrepreneur', 'Auto entrepreneur', 'confirmation'),
    new Reponse('Commerçant', 'Commerçant', 'confirmation'),
    new Reponse('Ecclésiastique', 'Ecclésiastique', 'confirmation'),
    new Reponse('Etudiant(e)', 'Etudiant', 'confirmation'),
    new Reponse('Exploitant agricole', 'Exploitant agricole', 'confirmation'),
    new Reponse('Fonctionnaire non sédentaire', 'Fonctionnaire non sédentaire', 'confirmation'),
    new Reponse('Fonctionnaire sédentaire', 'Fonctionnaire sédentaire', 'confirmation'),
    new Reponse('Gérant de société', 'Gérant de société', 'confirmation'),
    new Reponse('Profession libérale non sédentaire', 'Profession libérale non sédentaire', 'confirmation'),
    new Reponse('Profession libérale sédentaire', 'Profession libérale sédentaire', 'confirmation'),
    new Reponse('Sans profession', 'Sans profession', 'confirmation'),
    new Reponse('Retraité(e)', 'Retraite', 'confirmation'),
    new Reponse('TAXI', 'TAXI', 'confirmation'),
    new Reponse('VTC', 'VTC', 'confirmation'),
    new Reponse('VRP', 'VRP', 'confirmation'));
  }
  goBack(stepper: MatHorizontalStepper, currentStepKey?: string) {
    this.beforeGoBackIntercepter(stepper);
    const currStepKey = this._matStepperServiceService.getStepKeyByIndex(stepper.selectedIndex);
    this._matStepperServiceService.goBack(stepper, currStepKey);
    // parent.postMessage( 'goUP', 'https://zenithassurances.com' ); // Send message to iframe Parent
    this.sendMsgToParentOfIframe('goUP');
    this.afterGoBackIntercepter(stepper);
  }
  goForward(stepper: MatHorizontalStepper, nextIndex: number) {
    this.beforeGoForwardIntercepter(stepper, nextIndex);
    this.updatePreviousStepAndGoForwardByIndex(stepper, nextIndex);
    // parent.postMessage( 'goUP', 'https://zenithassurances.com' ); // Send message to iframe Parent
    this.sendMsgToParentOfIframe('goUP');
  }
  beforeGoBackIntercepter(stepper: MatHorizontalStepper) {
    const currStepKey = this._matStepperServiceService.getStepKeyByIndex(stepper.selectedIndex);
    switch (currStepKey) {
      case 'eteAssure36DerniersMois': // si on recule et on passe du conducteur secondaire au conducteur principal
        if (this.isConducteurSecondaireQuestion === true) {
          this.isConducteurSecondaireQuestion = false;
          this.initConducteurPrincipalReponsesOnGoBackFromConducteurSecondaireQuestion();
        }
        break;
    }
  }
  afterGoBackIntercepter(stepper: MatHorizontalStepper) {
    const currStepKey = this._matStepperServiceService.getStepKeyByIndex(stepper.selectedIndex);
    // console.log(currStepKey);
    switch (currStepKey) {
      // on recule et on passe du stupefiant au questions alco, on doit modifier l'etape precedente de la question sanctions pour retourner à la question alco
      case 'isEuStupefiant36DerniersMois':
        if (!this.formModel[this._typeConducteur].antecedents.isEuAlcoolemie36DerniersMois.toLowerCase().includes('non')) {
          if (this.currentQuestionIsAlcoolemieOrStupefiant === 'stupefiant') {
            this.updatePreviousStep(stepper, 'isAnnulationOuSuspensionPermis36DerniersMois', 'tauxAlcoolemie36DerniersMois');
          }
        }
        break;
    }
  }
  beforeGoForwardIntercepter(stepper: MatHorizontalStepper, nextIndex: number) {
    const currStepKey = this._matStepperServiceService.getStepKeyByIndex(nextIndex);
    switch (currStepKey) {
      case 'confirmation':
        // Before Confirmation processing
        if (this.formModel.conducteurPrincipal.antecedents.isEteResilie36DerniersMois === undefined ||
          this.formModel.conducteurPrincipal.antecedents.isEteResilie36DerniersMois === 0) {
          delete this.formModel.conducteurPrincipal.antecedents.dateResiliation36DerniersMois;
        }
        if (this.formModel.conducteurSecondaire.antecedents.isEteResilie36DerniersMois === undefined ||
          this.formModel.conducteurSecondaire.antecedents.isEteResilie36DerniersMois === 0) {
          delete this.formModel.conducteurSecondaire.antecedents.dateResiliation36DerniersMois;
        }
        if (this.formModel.conducteurPrincipal.typePermis === undefined || this.formModel.conducteurPrincipal.typePermis.toLowerCase() === 'union europeen') {
          this.formModel.conducteurPrincipal.isConduiteMaroc = 'Non';
          this.formModel.conducteurPrincipal.isConduiteTunisie = 'Non';
          this.formModel.conducteurPrincipal.isConduiteRussie = 'Non';
          this.formModel.conducteurPrincipal.isConduiteTurquie = 'Non';
        }
        if (this.formModel.conducteurSecondaire.typePermis === undefined || this.formModel.conducteurSecondaire.typePermis.toLowerCase() === 'union europeen') {
          this.formModel.conducteurSecondaire.isConduiteMaroc = 'Non';
          this.formModel.conducteurSecondaire.isConduiteTunisie = 'Non';
          this.formModel.conducteurSecondaire.isConduiteRussie = 'Non';
          this.formModel.conducteurSecondaire.isConduiteTurquie = 'Non';
        }
        this._backEndService.saveAutoForm(this.formModel).subscribe(data => {
          this.sendMsgToParentOfIframe('confirmation');
          window.location.href = 'https://assurancezenith.com:99/devis-api/ZenithTarificateurForApplication/?idfiches=' + data + '&sources=site';
        });
        break;
    }
  }
  updatePreviousStepAndGoForwardByIndex(stepper: MatHorizontalStepper, nextIndex: number) {
    const nextStepKey = this._matStepperServiceService.getStepKeyByIndex(nextIndex);
    const currentStepKey = this._matStepperServiceService.getStepKeyByIndex(stepper.selectedIndex);
    this._matStepperServiceService.updatePreviousStep(nextStepKey, currentStepKey);
    this._matStepperServiceService.goForward(stepper, nextIndex);
  }
  updatePreviousStepAndGoForward(stepper: MatHorizontalStepper, currentStepKey: string, nextStepKey: string) {
    this._matStepperServiceService.updatePreviousStep(nextStepKey, currentStepKey);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(nextStepKey));
  }
  updatePreviousStep(stepper: MatHorizontalStepper, stepKey: string, newPreviousStepKey: string) {
    this._matStepperServiceService.updatePreviousStep(stepKey, newPreviousStepKey);
  }
  onDateMecClick(stepper: MatHorizontalStepper) {
    this.formModel.vehicule.yearDateMEC = this._dateUtilsService.buildDateFromString(this.formModel.vehicule.dateMEC).year();
    this._carService.getMarquesByDateMEC(this.formModel.vehicule.yearDateMEC).subscribe(data => {
      this.isLoading = true;
      this.marquesPopular = data.marquesPopular;
      this.marquesNotPopular = data.marquesNotPopular;
      this.isLoading = false;
    });
    this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('dateMec', 1));
  }

  onMarqueClick(stepper: MatHorizontalStepper, marque: string) {
    this.formModel.vehicule.marque = marque;
    this._carService.getModelsByDateMECAndMarque(this.formModel.vehicule.yearDateMEC, this.formModel.vehicule.marque).subscribe(data => {
      this.models = data.models;
      this.isLoading = false;
    });
    this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('marque', 1));
  }

  onModelClick(stepper: MatHorizontalStepper, model: string) {
    this.formModel.vehicule.model = model;
    this._carService.getAlimentationsByDateMECAndMarqueAndModel(this.formModel.vehicule.yearDateMEC, this.formModel.vehicule.marque,
      this.formModel.vehicule.model).subscribe(data => {
      this.isLoading = true;
      this.alimentations = data.alimentations;
      this.isLoading = false;
      if (this.alimentations.length === 1) {
        this.onAlimentationClick(stepper, this.alimentations[0].alimentation, true, 'model');
        this._matStepperServiceService.updatePreviousStep('chevaux', 'model');
      } else if (this.alimentations.length > 1) {
        this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('model', 1));
      }

    });

  }

  onAlimentationClick(stepper: MatHorizontalStepper, alimentation: string, isCalledFromPrevFunction = false, previousStep?: string) {
    this.formModel.vehicule.alimentation =  alimentation;
    this._carService.getChevauxByDateMECAndMarqueAndModelAndAlimentation(this.formModel.vehicule.yearDateMEC, this.formModel.vehicule.marque
      , this.formModel.vehicule.model, this.formModel.vehicule.alimentation).subscribe(data => {
        this.isLoading = true;
        this.nombreChevaux = data.chevaux;
        this.isLoading = false;
        if (this.nombreChevaux.length === 1) {
          if (!isCalledFromPrevFunction) {
            this.onNombreChevauxClick(stepper, this.nombreChevaux[0].chevaux, true, 'alimentation');
          } else {
            this.onNombreChevauxClick(stepper, this.nombreChevaux[0].chevaux, true, previousStep);
          }
        } else if (this.nombreChevaux.length > 1) {
          if (isCalledFromPrevFunction) {
            this._matStepperServiceService.updatePreviousStep('chevaux', previousStep);
          }
          this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('alimentation', 1));
        }

      });

  }

  onNombreChevauxClick(stepper: MatHorizontalStepper, chevaux: number, isCalledFromPrevFunction = false, previousStep?: string) {
    this.formModel.vehicule.chevaux = chevaux;
    this._carService.getCarrosseriesByDateMECAndMarqueAndModelAndAlimentationAndChevaux(this.formModel.vehicule.yearDateMEC,
      this.formModel.vehicule.marque, this.formModel.vehicule.model, this.formModel.vehicule.alimentation, this.formModel.vehicule.chevaux)
      .subscribe(data => {
      this.isLoading = true;
      this.carrosseries = data.carrosseries;
      this.isLoading = false;
      if (this.carrosseries.length === 1) {
        if (!isCalledFromPrevFunction) {
          this.onCarrosserieClick(stepper, this.carrosseries[0].carrosserie, true, 'chevaux');
        } else {
          this.onCarrosserieClick(stepper, this.carrosseries[0].carrosserie, true, previousStep);
        }
      } else if (this.carrosseries.length > 1) {
        if (isCalledFromPrevFunction) {
          this._matStepperServiceService.updatePreviousStep('carrosserie', previousStep);
        }
        this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('chevaux', 1));
      }

    });
  }

  onCarrosserieClick(stepper: MatHorizontalStepper, carrosserie: string, isCalledFromPrevFunction = false, previousStep?: string) {
    this.formModel.vehicule.carrosserie = carrosserie;
    this._carService.getVersionsByDateMECAndMarqueAndModelAndAlimentationAndChevauxAndCarrosserie(this.formModel.vehicule.yearDateMEC,
      this.formModel.vehicule.marque, this.formModel.vehicule.model, this.formModel.vehicule.alimentation, this.formModel.vehicule.chevaux,
      this.formModel.vehicule.carrosserie).subscribe( data => {
       this.isLoading = true;
       this.versions = data.versions;
       this.isLoading = false;
       if (this.versions.length === 1) {
          if (!isCalledFromPrevFunction) {
           this.onVersionClick(stepper, this.versions[0].version, true, 'carrosserie');
          } else {
           this.onVersionClick(stepper, this.versions[0].version, true, previousStep);
           }
       } else if (this.versions.length > 1) {
          if (isCalledFromPrevFunction) {
            this._matStepperServiceService.updatePreviousStep('version', previousStep);
          }
          this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('carrosserie', 1));
       }
    });
  }

  onVersionClick(stepper: MatHorizontalStepper, version: string, isCalledFromPrevFunction = false, previousStep?: string) {
    this.formModel.vehicule.version = version;
    if (isCalledFromPrevFunction) {
      this._matStepperServiceService.updatePreviousStep('usage', previousStep);
    }
    this._carService.getCodeGtaByDateMECAndMarqueAndModelAndAlimentationAndChevauxAndCarrosserieAndVersion(this.formModel.vehicule.yearDateMEC,
      this.formModel.vehicule.marque, this.formModel.vehicule.model, this.formModel.vehicule.alimentation, this.formModel.vehicule.chevaux,
      this.formModel.vehicule.carrosserie, this.formModel.vehicule.version).subscribe( data => {
        this.formModel.vehicule.codeGta =  data.code_gta;
    });
    this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('version', 1));
  }

  onStationnementClick(stepper: MatHorizontalStepper, stationnementReponse: string) {
    this.formModel.vehicule.stationnement = stationnementReponse;
    this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('stationnement', 1));
  }

  onUsageClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.vehicule.usage = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onCodePostalProClick(stepper: MatHorizontalStepper) {
    if (this.codePostalProFormGroup.invalid) { return; }
    this.formModel.vehicule.codePostalPro = this.codePostalProFormGroup.get('codePostalPro').value;
    this._matStepperServiceService.updatePreviousStep('kilometrage', 'codePostalPro');
    this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('codePostalPro', 1));
  }
  onKilometrageClick(stepper: MatHorizontalStepper, kilometrageReponse: string) {
    this.formModel.vehicule.kilometrage = kilometrageReponse;
    this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('kilometrage', 1));
  }
  onFinancementClick(stepper: MatHorizontalStepper, financementReponse: string) {
    this.formModel.vehicule.financement = financementReponse;
    this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('financement', 1));
  }

  onRemorqueClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.vehicule.remorque = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onVehiculeAssureClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.vehicule.isActuellementAssure = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onVehiculeAmenagePMRClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.vehicule.isVehiculeAmenagePMR = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onEteAssure36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.bonusMalus = '1.00'; // bonusMalus init à 1 que ce soit la réponse Oui ou Non
    if (reponse.value.toLowerCase() === 'non' ) {
      this.formModel[this._typeConducteur].antecedents.isEteAssure36DerniersMois = 'Non';
    } else {
      this.formModel[this._typeConducteur].antecedents.isEteAssure36DerniersMois = 'Oui';
      this.formModel[this._typeConducteur].antecedents.isAssure36DerniersMoisAvec9MoisConsecutifs = 'Non';
      if (reponse.value.includes('ouiAvec9MoisConsecutifs')) {
        this.formModel[this._typeConducteur].antecedents.isAssure36DerniersMoisAvec9MoisConsecutifs = 'Oui';
      }
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onBonusMalusChange(value: number) {
    this.formModel[this._typeConducteur].antecedents.bonusMalus = value.toFixed(2);
  }
  onBonusMalusClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    // this.goForward(stepper, this._matStepperServiceService.getNextIndexByStepKey('bonusMalus', 1));
    // Condition pour ajouter la question nombre années passées en CRM 0.5
    this.formModel[this._typeConducteur].antecedents.bonusMalus = this.bonusMalusFormGroup.get('bonusMalus').value;
    console.log(this.formModel[this._typeConducteur].antecedents.bonusMalus);
    if (this.formModel[this._typeConducteur].antecedents.bonusMalus === '0.50') {
      reponse.nextStepKey = 'nbrAnneeBonusCinquante';
    } else {
      reponse.nextStepKey = 'periodeAssure36DerniersMois';
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onNbrAnneeBonusCinquanteClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.nbrAnneeBonusCinquante = parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onPeriodeAssure36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.periodeAssure36DerniersMois = parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onEteResilie36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.isEteResilie36DerniersMois =  parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onMotifResiliation36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.motifResiliation36DerniersMois = reponse.value;
    // En cas du motif de résiliation non paiement
    if (this.formModel[this._typeConducteur].antecedents.motifResiliation36DerniersMois.includes('paiement')) {
      this.dureeNonPaiementReponses = [];
      for (let i = 1; i <= 24; i++) {
        this.dureeNonPaiementReponses.push(new Reponse( '' + i, '' + i , 'nombreAssureursResiliationNonPaiement'));
      }
      this.nombreAssureursResiliationNonPaiementReponses = [];
      this.nombreAssureursResiliationNonPaiementReponses.push(new Reponse('1', '1', 'recidiveResiliationNonPaiement'),
        new Reponse('2', '2', 'recidiveResiliationNonPaiement'),
        new Reponse('3', '3', 'recidiveResiliationNonPaiement'),
        new Reponse('4', '4', 'recidiveResiliationNonPaiement'),
        new Reponse('5', '5', 'recidiveResiliationNonPaiement'),
        new Reponse('Plus de 5', 'plus de 5', 'recidiveResiliationNonPaiement'));
      this.recidiveResiliationNonPaiementReponses = [];
      this.recidiveResiliationNonPaiementReponses.push(new Reponse('Non', 'Non', 'contentieuxSoldeResiliationNonPaiement'),
        new Reponse('Oui', 'Oui', 'contentieuxSoldeResiliationNonPaiement'));
      this.contentieuxSoldeResiliationNonPaiementReponses = [];
      this.contentieuxSoldeResiliationNonPaiementReponses.push(new Reponse('Non', 'Non', 'dateResiliation36DerniersMois'),
        new Reponse('Oui', 'Oui', 'dateResiliation36DerniersMois'));
    }

    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
    // this.updatePreviousStepAndGoForward(stepper, 'motifResiliation36DerniersMois', reponse.nextStepKey);
  }

  onDureeNonPaiementClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.dureeNonPaiement = parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onAssureursResiliationNonPaiementClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.nombreAssureursResiliationNonPaiement = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onRecidiveResiliationNonPaiementClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.recidiveResiliationNonPaiement = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onContentieuxSoldeResiliationNonPaiementClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.contentieuxSoldeResiliationNonPaiement = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDateChange(data: any) {
    switch (data.fieldName) {
      case 'dateMEC':
        this.formModel.vehicule.dateMEC = data.date;
        break;
      case 'dateResiliation36DerniersMois':
        this.formModel[this._typeConducteur].antecedents.dateResiliation36DerniersMois = data.date;
        break;
      case 'dateSinistre_0':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[0].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_1':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[1].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_2':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[2].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_3':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[3].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_4':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[4].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_5':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[5].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_6':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[6].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_7':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[7].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_8':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[8].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_9':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[9].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateSinistre_10':
        this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[10].dateSinistre36DerniersMois = data.date;
        break;
      case 'dateDernierAlcoolemie36DerniersMois':
        this.formModel[this._typeConducteur].antecedents.alcoolemie.dateDernierAlcoolemie36DerniersMois = data.date;
        break;
      case 'dateDernierStupefiant36DerniersMois':
        this.formModel[this._typeConducteur].antecedents.stupefiant.dateDernierStupefiant36DerniersMois = data.date;
        break;
      case 'dateInitialPermisApresAnnulation':
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.dateInitialPermisApresAnnulation = data.date;
        break;
      case 'dateAnnulationPermis36DerniersMois':
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.dateAnnulationPermis36DerniersMois = data.date;
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.dateSanction36DerniersMois = data.date;
        break;
      case 'dateSuspensionPermis36DerniersMois':
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.dateSuspensionPermis36DerniersMois = data.date;
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.dateSanction36DerniersMois = data.date;
        break;
      case 'dateInfraction36DerniersMois':
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.dateInfraction36DerniersMois = data.date;
        break;
      case 'dateSanction36DerniersMois':
        switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
          case 'alcoolemie':
            this.formModel[this._typeConducteur].antecedents.alcoolemie.sanction.dateAnnulationPermis36DerniersMois = data.date;
            break;
          case 'stupefiant':
            this.formModel[this._typeConducteur].antecedents.stupefiant.sanction.dateSuspensionPermis36DerniersMois = data.date;
            break;
        }
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.dateSanction36DerniersMois = data.date;
        break;
      case 'dateNaissanceConducteurPrincipal':
        this.formModel[this._typeConducteur].dateNaissance = data.date;
        break;
      case 'datePermisConducteurPrincipal':
        this.formModel[this._typeConducteur].datePermis = data.date;
        break;
    }
  }

  onDateResiliation36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onIsEuSinistres36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.isEuSinistres36DerniersMois = reponse.value;
    if (!this.formModel[this._typeConducteur].antecedents.isEuSinistres36DerniersMois.toLowerCase().includes('non')) {
      const nombreSinistresADeclarer = parseInt(this.formModel[this._typeConducteur].antecedents.isEuSinistres36DerniersMois, 10);
      this.formModel[this._typeConducteur].antecedents.isEuSinistres36DerniersMois = 'Oui';
      this._matStepperServiceService.updatePreviousStep('isEuAlcoolemie36DerniersMois', 'dateSinistre36DerniersMois_' + (nombreSinistresADeclarer - 1));
      this.dateSinistre36DerniersMoisReponse[nombreSinistresADeclarer - 1] = new Reponse('Valider', 'Valider', 'isEuSanctionsPenalesOuAdministratives');
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onNatureSinistres36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse, indexSinistre: number) {
    this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[indexSinistre].natureSinistre36DerniersMois = reponse.value;
    /*
    if (reponse.value.toLowerCase().includes('corporel')) {
    onsole.log('materieel !!!');
  for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {
    this.isDelitDeFuiteSinistres36DerniersMoisReponses[i] = [new Reponse('Non', 'Non', 'isPresenceTiersSinistres36DerniersMois_'.concat( (i).toString() ) ),
      new Reponse('Oui', 'Oui', 'isPresenceTiersSinistres36DerniersMois_'.concat( (i).toString() ))];
  }
    for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {
      this.isPresenceTiersSinistres36DerniersMoisReponses[i] = [new Reponse('Non', 'Non', 'dateSinistre36DerniersMois_'.concat((i).toString())),
        new Reponse('Oui', 'Oui', 'dateSinistre36DerniersMois_'.concat((i).toString()))];
    }
  }
  */
    /*
    switch (reponse.value) {
      case '':
        return '';
      default :
        return '';
    }
    */

    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onDelitDeFuiteSinistres36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse, indexSinistre: number) {
    this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[indexSinistre].isDelitDeFuiteSinistre36DerniersMois =  reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onInterventionForceDeLOrdreSinistres36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse, indexSinistre: number) {
    this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[indexSinistre].isInterventionForceDeLOrdreSinistres36DerniersMois =  reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onPoursuiteTribunalPoliceSinistres36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse, indexSinistre: number) {
    this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[indexSinistre].poursuiteTribunalPoliceSinistres36DerniersMois =  reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onPresenceTiersSinistres36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse, indexSinistre: number) {
    this.formModel[this._typeConducteur].antecedents.sinistres36DerniersMois[indexSinistre].isPresenceTiersSinistres36DerniersMois =  reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDateSinistre36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse, indexSinistre: number) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onIsEuSanctionsPenalesOuAdministrativesClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onIsEuAlcoolemie36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.isEuAlcoolemie36DerniersMois = reponse.value;
    if (!this.formModel[this._typeConducteur].antecedents.isEuAlcoolemie36DerniersMois.toLowerCase().includes('non')) {
      this.formModel[this._typeConducteur].antecedents.isEuAlcoolemie36DerniersMois = 'Oui';
      this.formModel[this._typeConducteur].antecedents.alcoolemie.nombreControlesPositifsAlcoolemie36DerniersMois = parseInt(reponse.value, 10);
      this.currentQuestionIsAlcoolemieOrStupefiant = 'alcoolemie';
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onDateDernierAlcoolemie36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onIsRefusTestAlcoolemie36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.alcoolemie.isRefusTestAlcoolemie36DerniersMois = reponse.value;
    // si la reponse est Non, on saute les questions (method du test et le taux d'alcoolemie)
    if (this.formModel[this._typeConducteur].antecedents.alcoolemie.isRefusTestAlcoolemie36DerniersMois.toLowerCase().includes('oui')) {
      this.controleAlcoolemieSuiteA36DerniersMoisReponses = [];
      this.controleAlcoolemieSuiteA36DerniersMoisReponses.push(new Reponse('Contrôle routier', 'Controle routier', 'isAnnulationOuSuspensionPermis36DerniersMois'),
        new Reponse('Sinistre', 'sinistre', 'isAnnulationOuSuspensionPermis36DerniersMois'));
      this.formModel[this._typeConducteur].antecedents.alcoolemie.controleAlcoolemieMethode36DerniersMois = 'prise de sang';
      this.formModel[this._typeConducteur].antecedents.alcoolemie.tauxAlcoolemie = 2;
    } else {
      this.controleAlcoolemieSuiteA36DerniersMoisReponses = [];
      this.controleAlcoolemieSuiteA36DerniersMoisReponses.push(new Reponse('Contrôle routier', 'Controle routier', 'controleAlcoolemieMethode36DerniersMois'),
        new Reponse('Sinistre', 'sinistre', 'controleAlcoolemieMethode36DerniersMois'));
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onIsDelitDeFuiteAlcoolemie36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.alcoolemie.isDelitDeFuiteAlcoolemie36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onControleAlcoolemieSuiteA36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.alcoolemie.controleAlcoolemieSuiteA36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onControleAlcoolemieMethodeDerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.alcoolemie.controleAlcoolemieMethode36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onTauxAlcoolemieClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    if (this.tauxAlcoolemieFormGroup.invalid) { return; }
    this.formModel[this._typeConducteur].antecedents.alcoolemie.tauxAlcoolemie = this.tauxAlcoolemieFormGroup.get('tauxAlcoolemie').value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onIsEuStupefiant36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.isEuStupefiant36DerniersMois = reponse.value;
    if (!this.formModel[this._typeConducteur].antecedents.isEuStupefiant36DerniersMois.toLowerCase().includes('non')) {
      this.formModel[this._typeConducteur].antecedents.isEuStupefiant36DerniersMois = 'Oui';
      this.formModel[this._typeConducteur].antecedents.stupefiant.nombreControlesPositifsStupefiants36DerniersMois = parseInt(reponse.value, 10);
      this.currentQuestionIsAlcoolemieOrStupefiant = 'stupefiant';
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onDateDernierStupefiant36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onControleStupefiantSuiteA36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.stupefiant.controleStupefiantSuiteA36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onControleStupefiantMethodeDerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.stupefiant.controleStupefiantMethode36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onIsRefusTestStupefiant36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.stupefiant.isRefusTestStupefiant36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onIsDelitDeFuiteStupefiant36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents.stupefiant.isDelitDeFuiteStupefiant36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onIsAnnulationOuSuspensionPermis36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].isAnnulationOuSuspensionPermis36DerniersMois = reponse.value;
    /*
    switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
      case 'alcoolemie':
        this.formModel[this._typeConducteur].antecedents.alcoolemie.isAnnulationOuSuspensionPermis36DerniersMois = reponse.value;
        break;
      case 'stupefiant':
        // this.formModel[this._typeConducteur].antecedents.stupefiant5DernieresAnnees.isAnnulationOuSuspensionPermis36DerniersMois = reponse.value;
        break;
    }*/
    const annualtions = ['annulation_permis', 'ANNULATION_PERMIS_PEINE_PRISON'];
    if (annualtions.includes(reponse.value)) {
      this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.typeAnnulationPermis36DerniersMois = 'Annulation permis';
      this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.typeSanction = 'Annulation permis';
      switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
        case 'alcoolemie':
          this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'isEuStupefiant36DerniersMois';
          this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.annulationPermisMotif36DerniersMois = 'Alcoolemie';
          break;
        case 'stupefiant':
          this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'civiliteConducteurPrincipale';
          this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.annulationPermisMotif36DerniersMois = 'Stupefiant';
          break;
      }
    }
    const suspensions = ['suspension_permis', 'SUSPENSION_PERMIS_PEINE_PRISON'];
    if (suspensions.includes(reponse.value)) {
      this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'suspensionPermisMotif36DerniersMois';
      this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.typeSuspensionPermis36DerniersMois = 'Suspension permis';
      this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.typeSanction = 'Suspension permis';
      switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
        case 'alcoolemie':
          this.nombreMoisSuspensionPermis36DerniersMoisReponses = [];
          for (let i = 1; i <= 36; i++) {this.nombreMoisSuspensionPermis36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'isEuStupefiant36DerniersMois')); }
          this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.suspensionPermisMotif36DerniersMois = 'Alcoolemie';
          break;
        case 'stupefiant':
          this.nombreMoisSuspensionPermis36DerniersMoisReponses = [];
          for (let i = 1; i <= 36; i++) {this.nombreMoisSuspensionPermis36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'civiliteConducteurPrincipale')); }
          this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.suspensionPermisMotif36DerniersMois = 'Stupefiant';
          break;
      }
    }

    const aucuneOrContraventionOrPeinePrison = ['AUCUNE', 'CONTRAVENTION_4', 'PEINE_PRISON'];
    if (aucuneOrContraventionOrPeinePrison.includes(reponse.value)) {
      this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.typeSanction = reponse.value;
      switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
        case 'alcoolemie':
          reponse.nextStepKey = 'isEuStupefiant36DerniersMois';
          break;
        case 'stupefiant':
          reponse.nextStepKey = 'civiliteConducteurPrincipale';
          break;
      }
    }
    const attenteJugementOrCompositionPenal = ['ATTENTE_JUGEMENT', 'COMPOSITION_PENALE'];
    if (attenteJugementOrCompositionPenal.includes(reponse.value)) {
      this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.typeSanction = reponse.value;
      switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
        case 'alcoolemie':
          this.dureeSanction36DerniersMoisReponses = [];
          for (let i = 1; i <= 36; i++) {this.dureeSanction36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'isEuStupefiant36DerniersMois')); }
          break;
        case 'stupefiant':
          this.dureeSanction36DerniersMoisReponses = [];
          for (let i = 1; i <= 36; i++) {this.dureeSanction36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'civiliteConducteurPrincipale')); }
          break;
      }
    }
    /*
    switch (reponse.value) {
      case 'annulation_permis':
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].typeAnnulationPermis36DerniersMois = 'Annulation permis';
        switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
          case 'alcoolemie':
            this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'isEuStupefiant36DerniersMois';
            this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.annulationPermisMotif36DerniersMois = 'Alcoolemie';
            break;
          case 'stupefiant':
            this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'civiliteConducteurPrincipale';
            this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.annulationPermisMotif36DerniersMois = 'Stupefiant';
            break;
        }
        break;
      case 'suspension_permis':
        this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'suspensionPermisMotif36DerniersMois';
        this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.typeSuspensionPermis36DerniersMois = 'Suspension permis';
        switch (this.currentQuestionIsAlcoolemieOrStupefiant) {
          case 'alcoolemie':
            this.nombreMoisSuspensionPermis36DerniersMoisReponses = [];
            for (let i = 1; i <= 36; i++) {this.nombreMoisSuspensionPermis36DerniersMoisReponses.push(new Reponse('' + i, '' + i, 'isEuStupefiant36DerniersMois')); }
            this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.suspensionPermisMotif36DerniersMois = 'Alcoolemie';
            break;
          case 'stupefiant':
            this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.suspensionPermisMotif36DerniersMois = 'Stupefiant';
            break;
        }
        break;
      case 'annulation_et_suspension_permis':
        this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'suspensionPermisMotif36DerniersMois';
        this.formModel[this._typeConducteur].antecedents.typeAnnulationPermis36DerniersMois = 'Annulation permis';
        this.formModel[this._typeConducteur].antecedents.typeSuspensionPermis36DerniersMois = 'Suspension permis';
        break;
    }
    */
    /*
    if (reponse.value === 'annulation_permis') {
      this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'civiliteConducteurPrincipale';
      this.formModel[this._typeConducteur].antecedents.typeAnnulationPermis36DerniersMois = 'Annulation permis';
    } else if (['suspension_permis', 'annulation_et_suspension_permis'].includes(reponse.value)) {
      this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'suspensionPermisMotif36DerniersMois';
      this.formModel[this._typeConducteur].antecedents.typeSuspensionPermis36DerniersMois = 'Suspension permis';
    } else if (reponse.value === 'annulation_et_suspension_permis') {
      this.dateAnnulationPermis36DerniersMoisReponse.nextStepKey = 'suspensionPermisMotif36DerniersMois';
    }
     */
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onAnnulationPermisAvecOuSansSinistre36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: any) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.annulationPermisAvecOuSansSinistre36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onAnnulationPermisMotif36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.annulationPermisMotif36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onDateInitialPermisApresAnnulationClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDateAnnulationPermis36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onSuspensionPermisMotif36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.suspensionPermisMotif36DerniersMois = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDateSuspensionPermis36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onNombreSuspensionPermis36AvecSinistreDerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.nombreSuspensionPermis36AvecSinistreDerniersMois = parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onNombreSuspensionPermis36SansSinistreDerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.nombreSuspensionPermis36SansSinistreDerniersMois =  parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onNombreMoisSuspensionPermis36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.nombreMoisSuspensionPermis36DerniersMois =  parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDateInfraction36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDateSanction36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDureeSanction36DerniersMoisClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].antecedents[this.currentQuestionIsAlcoolemieOrStupefiant].sanction.nombreMoisSuspensionPermis36DerniersMois =  parseInt(reponse.value, 10);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onCiviliteConducteurPrincipaleClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].civilite = reponse.value;
    // console.log(this.formModel);
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

  onNomConducteurPrincipaleClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].nom = this.nomConducteurPrincipaleFormGroup.get('nom').value;
    this.formModel[this._typeConducteur].prenom = this.nomConducteurPrincipaleFormGroup.get('prenom').value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDateNaissanceConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    if (this._typeConducteur === 'conducteurSecondaire' && this.formModel.conducteurSecondaire.dateNaissance === undefined) {
      this.formModel.conducteurSecondaire.dateNaissance = this.formModel.conducteurPrincipal.dateNaissance; // on met une date par defaut
    }
    if (this.formModel[this._typeConducteur].dateNaissance !== undefined) {
      this.defaultFormValues.datePermisDefaultYearProspect  = this._dateUtilsService.buildDateFromString(this.formModel[this._typeConducteur].dateNaissance).year() + 18;
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onDatePermisConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onTypePermisConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].typePermis = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onPaysConduiteHorsEuropeConducteurPrincipalReponseClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    if (this.formModel[this._typeConducteur].isConduiteMaroc === true) {this.formModel[this._typeConducteur].isConduiteMaroc = 'Oui';
    } else { this.formModel[this._typeConducteur].isConduiteMaroc = 'Non'; }
    if (this.formModel[this._typeConducteur].isConduiteTunisie === true) {this.formModel[this._typeConducteur].isConduiteTunisie = 'Oui';
    } else { this.formModel[this._typeConducteur].isConduiteTunisie = 'Non'; }
    if (this.formModel[this._typeConducteur].isConduiteRussie === true) {this.formModel[this._typeConducteur].isConduiteRussie = 'Oui';
    } else { this.formModel[this._typeConducteur].isConduiteRussie = 'Non'; }
    if (this.formModel[this._typeConducteur].isConduiteTurquie === true) {this.formModel[this._typeConducteur].isConduiteTurquie = 'Oui';
    } else { this.formModel[this._typeConducteur].isConduiteTurquie = 'Non'; }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onTitulaireCarteGriselClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.titulaireCarteGrise = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onSituationFamilialeConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].situationFamiliale = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onLienAvecConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.conducteurSecondaire.lienAvecConducteurPrincipal = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onProfessionConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].profession = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onAdresseConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].adresse = this.adresseConducteurPrincipaleFormGroup.get('adresse').value;
    this.formModel[this._typeConducteur].codePostal = this.adresseConducteurPrincipaleFormGroup.get('codePostal').value;
    this.formModel[this._typeConducteur].ville = this.adresseConducteurPrincipaleFormGroup.get('ville').value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onContactConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel[this._typeConducteur].tel = this.contactConducteurPrincipaleFormGroup.get('tel').value;
    this.formModel[this._typeConducteur].email = this.contactConducteurPrincipaleFormGroup.get('email').value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onGarantieSouhaiteeConducteurPrincipalClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.garantieSouhaiteeConducteurPrincipal = reponse.value;
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }
  onIsAjouterConducteurSecondairClick(stepper: MatHorizontalStepper, reponse: Reponse) {
    this.formModel.isAjouterConducteurSecondaire = reponse.value;
    if (reponse.value.toLowerCase() === 'oui') {
      this.isConducteurSecondaireQuestion = true;
      this.initConducteurSecondaireReponses();
    }
    this.goForward(stepper, this._matStepperServiceService.getIndexByStepKey(reponse.nextStepKey));
  }

}
